<ng-container *ngIf="order">
    <ng-container *ngTemplateOutlet="mobileDevice ? mobileView : desktopView"></ng-container>
</ng-container>


<ng-template #desktopView>
    <div  class="order-info--container mr-3">
        <div class="order-info--container--header pb-3 line-separator--grey">
            <h3  class="m-0" *ngIf="order.started_at">Order Date: {{ formatedOrderDate(order.started_at.date)}}</h3>
            <h1 class="m-0">Order #{{order.id}}</h1>
            <div>
<!--                <button class="btn btn-icon large with-border with-shadow background-white mr-2" title="Export to Excel" (click)="exportToExcel()"><i class="fal fa-file-excel"></i></button>-->
<!--                <button class="btn btn-icon large with-border with-shadow background-white" title="Export to PDF" (click)="exportToPDF()"><i class="fal fa-file-pdf"></i></button>-->
            </div>
        </div>
        <div class="order-info--container--details mt-3">
            <div>
                <div><span class="font-weight-bold">Name: </span><span>{{order.attr_cart_name}}</span></div>
                <div *ngIf='showNotes'><span class="font-weight-bold">{{orderNotesLabel}}: </span><span>{{order.attr_notes}}</span></div>
                <div *ngIf='showPlanningComments'>
                    <span class="font-weight-bold">Planning Comments: </span><span>{{order.attr_planning_comments}}</span>
                </div>
            </div>
            <div>
                <div><span class="font-weight-bold">Status: </span><span>{{isOrderCut ? 'Cut' : status}}</span></div>
                <div *ngIf="showBillingInfo"><span class="font-weight-bold">Payment Method: </span><span>{{paymentMethod}}</span></div>
                <div *ngIf="showBillingInfo && order.costCenter"><span class="font-weight-bold">Billing Code: </span><span>{{order.costCenter.getLongAccount()}}</span></div>
                <div *ngIf="showBillingInfo && order.creditCard"><span class="font-weight-bold">Card Name: </span><span>{{order.creditCard.label}}</span></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mobileView>
    <div  class="order-info--container mobile">
        <div class="order-info--container--header pb-3 line-separator--grey">
            <h1 class="m-0">Order #{{order.id}}</h1>
            <h5  class="m-0" *ngIf="order.started_at">Order Date: {{ formatedOrderDate(order.started_at.date)}}</h5>
            <div class="mt-3">
<!--                <button class="btn btn-icon large with-border with-shadow background-white mr-2" title="Export to Excel" (click)="exportToExcel()"><i class="fal fa-file-excel"></i></button>-->
<!--                <button class="btn btn-icon large with-border with-shadow background-white " title="Export to PDF" (click)="exportToPDF()"><i class="fal fa-file-pdf"></i></button>-->
            </div>
        </div>
        <div class="order-info--container--details mt-3">
            <div>
                <div><span class="font-weight-bold">Name: </span><span>{{order.attr_cart_name}}</span></div>
                <div><span class="font-weight-bold">Status: </span><span>{{isOrderCut ? 'Cut' : status}}</span></div>
                <div *ngIf="showBillingInfo"><span class="font-weight-bold">Payment Method: </span><span>{{paymentMethod}}</span></div>
                <div *ngIf="showBillingInfo && order.costCenter"><span class="font-weight-bold">Billing Code: </span><span>{{order.costCenter.getLongAccount()}}</span></div>
                <div *ngIf="showBillingInfo && order.creditCard"><span class="font-weight-bold">Card Name: </span><span>{{order.creditCard.label}}</span></div>
                <div *ngIf='showNotes'><span class="font-weight-bold">{{orderNotesLabel}}: </span><span>{{order.attr_notes}}</span></div>
                <div *ngIf='showPlanningComments'><span class="font-weight-bold">Planning Comments: </span><span>{{order.attr_planning_comments}}</span></div>
            </div>
        </div>
    </div>
</ng-template>


